import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { ChangeUnit } from '@routes/change_unit/mod';
import { createRoot, Root } from 'react-dom/client';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactHeaderComponent';

@Component({
	standalone: false,
	selector: 'change-unit-component',
	template: `
		<semantic-view>
			<header-component header></header-component>
			<div class="wrapper-container" #${containerElementName}></div>
			<footer-component footer></footer-component>
		</semantic-view>
	`,
	encapsulation: ViewEncapsulation.None,
})
export class ChangeUnitWrapperComponent implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) public containerRef: ElementRef;

	private root: Root;
	public extraHeaderHeight: boolean = false;

	constructor(private readonly ngZone: NgZone) {}

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper>
					<ChangeUnit />
				</CellulaProviderWrapper>,
			);
		});
	}
}
